import * as Sentry from "@sentry/browser";
import { isPublicUrl } from "Shared/utils/isPublicUrl";
import axios from "axios";

function install(Vue, app) {
  if (install.installed) {
    return;
  }
  install.installed = true;

  if (!app.$snotify) {
    console.error("You have to install Snotify");
    return;
  }

  axios.interceptors.response.use(
    (r) => r,
    (e) => {
      if (
        e.response &&
        e.response.data &&
        typeof e.response.data.authenticationException !== undefined &&
        e.response.data.authenticationException
      ) {
        if (!isPublicUrl()) {
          window.location.reload();
        }
      }
      if (!e.response) return;
      if (e.response.status === 422) {
        Sentry.captureException(e);
      }
      if (e.response.status === 409) {
        return Promise.reject(e);
      }
      if (e.response.data.errors) {
        app.$snotify.validation(
          e.response.data.errors || {},
          e.response.data.message || "The given data was invalid."
        );
      } else {
        let error = "";
        switch (e.response.status) {
          case 401:
            if (!window.location.href.includes("/login")) {
              const query = {};
              if (!window.location.href.includes("/logout"))
                query.next = window.location.href;
              app.$router.push({
                name: "login",
                params: { pass: true },
                query,
              });
            }
            break;
          case 413:
            error = "Allowed upload size exceeded.";
            break;

          default:
            if (e.response.data && e.response.data.message) {
              error = e.response.data.message;
            } else {
              error = "A server error has occurred.";
            }
            break;
        }
        if (e.response.status !== 401) {
          app.$snotify.error(error);
        }
      }

      return Promise.reject(e);
    }
  );
}

export default install;
